The result for the `verifyCandidate` mutation when verification is disabled by the hirer.
